import { ListItemIcon, SvgIcon } from "@mui/material";
import type React from "react";
import { Settings as SettingsIcon } from "react-feather";
import { RiStore2Line } from "react-icons/ri";

import { AllIcon } from "src/components/generics/icons/AllIcon";
import { PosGroupIcon } from "src/components/generics/icons/PosGroupIcon";
import { ReservedId } from "src/constants";

import type { Element } from "../NestedSelect";
import { useElementIconStyles } from "./ElementIcon.styles";

type ElementType = "all" | "single" | "group" | "organization";

const getElementType = (element: Element): ElementType => {
    switch (element.value) {
        case ReservedId.ALL_POSS_ID:
            return "all";
        case ReservedId.ORGANIZATION_ID:
            return "organization";
        default: {
            return element.nested ? "group" : "single";
        }
    }
};

interface ElementIconProps {
    element: Element;
}

export const ElementIcon: React.FC<ElementIconProps> = ({ element }): JSX.Element => {
    const classes = useElementIconStyles();

    return (
        <ListItemIcon sx={{ marginLeft: 1 }}>
            {
                {
                    all: <AllIcon />,
                    single: <RiStore2Line className={classes.iconStartSecondary} />,
                    group: <PosGroupIcon className={classes.iconStart} />,
                    organization: (
                        <SvgIcon className={classes.iconOrganization} fontSize="small">
                            <SettingsIcon />
                        </SvgIcon>
                    ),
                }[getElementType(element)]
            }
        </ListItemIcon>
    );
};
